import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "./components/index"

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 个人中心二级页的公共视觉层。必须放在 Element 样式之后，
// 这样同名的规则我的在后、才能压住 Element 的默认值。
// 文件内所有规则都以 .pg-page 打头，只对主动挂了这个类的页面生效。
import './styles/personage.scss';

// ---------------------------------------------------------------------------
// 全站字体（2026-09-15 第四轮）
// Noto Sans SC = 思源黑体的 Google 版本，许可证 **SIL Open Font License 1.1**，
// 允许免费商用、可再分发。用 npm 包 @fontsource/noto-sans-sc **本地自托管**，
// 不依赖任何第三方 CDN；它按 unicode-range 切成 101 片，浏览器只会下载页面
// 实际用到的那几片（通常 100~200KB），不会把整套 2.6MB 拉下来。
// 只引 400 / 700 两个字重，其余字重由浏览器合成，够用且体积最小。
// ⚠️ 全链路没有引入任何需要付费授权的商业字库。
import '@fontsource/noto-sans-sc/400.css';
import '@fontsource/noto-sans-sc/700.css';
// 字号层级 + Element UI 兜底 + 版式小工具，同样必须放在 Element 样式之后
import './styles/site-polish.scss';
import store from './store';
//基准大小
const baseFontSize = 20
import {getAesString,decryptAesString} from '@/utils/encryption'
//设置 rem 函数
function setResponsiveFontSize() {
  const baseWidth = 1920; // 基准宽度
  // const baseFontSize = 24; // 基准字体大小
  const currentWidth = window.innerWidth;
  const scaleFactor = currentWidth / baseWidth;

  document.documentElement.style.fontSize = baseFontSize * scaleFactor + 'px';
}

// 初始化时执行一次
setResponsiveFontSize();

// 监听窗口大小变化
window.addEventListener('resize', setResponsiveFontSize);
Vue.prototype.$bus = new Vue();
Vue.prototype.getAesString = getAesString
Vue.prototype.decryptAesString = decryptAesString
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
